import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "iparque-components";
import styled from "styled-components";

interface Props {
  hasErrors?: boolean;
}

const RequiredFieldsMessage = ({ hasErrors = false }: Props) => {
  const { t } = useTranslation();

  return (
    <Text
      className="mt-20 inline"
      variant="body8"
      color={hasErrors ? "danger" : "quaternary"}
    >
      <Asterisk variant="body8" color="danger">
        *
      </Asterisk>
      {t("4197") /* Campos obrigatórios */}
    </Text>
  );
};

export const Asterisk = styled(Text)(() => ({
  marginRight: "3px",
}));

export default RequiredFieldsMessage;
